import DOMPurify from 'dompurify';

/* ------------------------------------------------------------------
   HTML from somewhere else, made safe to put in the page.

   The newsletter is written by a model that is handed text members typed,
   and it is shown here inside the admin's own session — where a script in
   it would run with the admin's login. The server cleans the letter when
   it is written and saved (server/utils/newsletterHtml.js); this is the
   second lock on the same door, and the only one for a draft stored
   before the server started cleaning.

   DOMPurify's defaults already remove scripts, event handlers and
   javascript: links. On top of that: no <style> block (it would restyle
   the whole app, not just the letter), and nothing interactive.
   data-* attributes are kept, because the editor uses data-gs-src to
   remember where a picture's real address is.
   ------------------------------------------------------------------ */
export function safeHtml(html) {
  return DOMPurify.sanitize(String(html || ''), {
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select', 'iframe', 'object', 'embed', 'link', 'meta', 'base'],
    FORBID_ATTR: ['srcset', 'formaction'],
    ALLOW_DATA_ATTR: true,
  });
}
